import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class TicketService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.TICKET = '/api/ticket';

        this.GET_BY_ID = '/{id}';
        this.GET_LIST_BY_PROJECT_ID = '/list/project/{projectId}';
        this.GET_LIST_BY_PROJECT_ID_PAGE_SORT_FILTER = '/list/project/{projectId}';
        this.GET_LIST_BY_CREATED_TYPE_AND_CREATED_ID = '/list/type/{createdByType}/id/{createdById}';
        this.GET_LIST_BY_CREATED_TYPE_AND_CREATED_ID_AND_UNRESOLVED = '/list/unresolved/type/{createdByType}/id/{createdById}';
        this.GET_LIST_BY_CREATED_TYPE_AND_CREATED_ID_AND_PROJECT_ID = '/list/type/{createdByType}/id/{createdById}/project/{projectId}';

        this.GET_ANALYSIS_BY_PROJECT = '/analysis/project/{projectId}';
        this.GET_ANALYSIS_BY_FORM = '/analysis/form/{formId}';
        this.GET_FEEDBACK_ANALYSIS_BY_FORM = '/analysis/feedback/form/{formId}';
        this.GET_ANALYSIS_BY_FORM_AND_USER = '/analysis/form-user';
        this.SEARCH_BY_KEYWORD_AND_PROJECT_ID = '/list/search/keyword{keyword}/project/{projectId}';
        this.UPDATE_TICKET_STATUS = '/update/status';
        this.UPDATE_TICKET_REPORTER = '/update/reporter';
        this.UPDATE_TICKET_PRIORITY = '/update/priority';
        this.ADD_CLIENT_COMMENT = '/add/client-comment';
        this.ADD_DISCUSSION_COMMENT = '/add/discussion-comment';
        this.ESCALATE_TICKET = '/escalate';
        this.UPDATE_TICKET_ASSIGNEE = '/update/assignee';
        this.GET_AS_PDF = '/pdf/{type}/ticket/{id}';
        this.GET_DASHBOARD_ASSIGNED_TICKETS = '/dashboard/assigned/project/{projectId}';
        this.GET_DASHBOARD_ESCALATED_STALE_TICKETS = '/dashboard/escalated-stale/project/{projectId}';
        this.GET_COMMENTS_AND_UPLOAD_FILES = '/get-comments/upload/{ticketId}';
        this.GET_DASHBOARD_USER_ANALYTICS = '/dashboard/user-analytics/project/{projectId}';


    }

    async getTicket(id) {
        try {
            let url = window.location.origin + this.TICKET + this.GET_BY_ID;
            url = url
                .replace('{id}', id)
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getTicketListByProjectId(projectId) {
        try {
            let url = window.location.origin + this.TICKET + this.GET_LIST_BY_PROJECT_ID;
            url = url
                .replace('{projectId}', projectId)
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getTicketListByProjectIdSortedAndFiltered(projectId, page, size, sortBy, order, filterBy, filterValue, statusList) {
        try {
            let url = window.location.origin + this.TICKET + this.GET_LIST_BY_PROJECT_ID_PAGE_SORT_FILTER;
            url = url
                .replace('{projectId}', projectId);
            url = url + '?page=' + page + '&size=' + size + '&sortBy=' + sortBy + '&order=' + order + '&filterBy=' + filterBy + '&filterValue=' + filterValue + '&statusList=%5B' + statusList + '%5D';
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getTicketListByCreatedByTypeAndCreatedById(createdByType, createdById) {
        try {
            let url = window.location.origin + this.TICKET + this.GET_LIST_BY_CREATED_TYPE_AND_CREATED_ID;
            url = url
                .replace('{createdByType}', createdByType)
                .replace('{createdById}', createdById)
            const ticketDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return ticketDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getTicketListByCreatedByTypeAndCreatedByIdAndUnresolved(createdByType, createdById) {
        try {
            let url = window.location.origin + this.TICKET + this.GET_LIST_BY_CREATED_TYPE_AND_CREATED_ID_AND_UNRESOLVED;
            url = url
                .replace('{createdByType}', createdByType)
                .replace('{createdById}', createdById)
            const ticketDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return ticketDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getTicketListByCreatedByTypeAndCreatedByIdAndProjectId(createdByType, createdById, projectId, page, size, sortBy, order, filterBy, filterValue, statusList) {
        try {
            let url = window.location.origin + this.TICKET + this.GET_LIST_BY_CREATED_TYPE_AND_CREATED_ID_AND_PROJECT_ID;
            url = url
                .replace('{createdByType}', createdByType)
                .replace('{createdById}', createdById)
                .replace('{projectId}', projectId);
            url = url + '?page=' + page + '&size=' + size + '&sortBy=' + sortBy + '&order=' + order + '&filterBy=' + filterBy + '&filterValue=' + filterValue + '&statusList=%5B' + statusList + '%5D';
            const ticketDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return ticketDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getAnalysisInProject(projectId) {
        try {
            let url = window.location.origin + this.TICKET + this.GET_ANALYSIS_BY_PROJECT;
            url = url
                .replace('{projectId}', projectId)
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getAnalysisByForm(formId) {
        try {
            let url = window.location.origin + this.TICKET + this.GET_ANALYSIS_BY_FORM;
            url = url
                .replace('{formId}', formId)
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getDashboardAssignedTickets(projectId, { page = 0, pageSize = 10, statusValue, labelIds, sortBy } = {}) {
        try {
            let url = window.location.origin + this.TICKET + this.GET_DASHBOARD_ASSIGNED_TICKETS;
            url = url.replace('{projectId}', projectId) + '?page=' + page + '&pageSize=' + pageSize;
            if (statusValue) url += '&statusValue=' + encodeURIComponent(statusValue);
            if (labelIds && labelIds.length > 0) url += '&labelIds=' + labelIds.join(',');
            if (sortBy) url += '&sortBy=' + encodeURIComponent(sortBy);
            const ticketDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return ticketDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getDashboardEscalatedStaleTickets(projectId, staleDays = 5, { page = 0, pageSize = 10, statusValue, assigneeUserId, labelIds, sortBy } = {}) {
        try {
            let url = window.location.origin + this.TICKET + this.GET_DASHBOARD_ESCALATED_STALE_TICKETS;
            url = url.replace('{projectId}', projectId) + '?staleDays=' + staleDays + '&page=' + page + '&pageSize=' + pageSize;
            if (statusValue) url += '&statusValue=' + encodeURIComponent(statusValue);
            if (assigneeUserId) url += '&assigneeUserId=' + assigneeUserId;
            if (labelIds && labelIds.length > 0) url += '&labelIds=' + labelIds.join(',');
            if (sortBy) url += '&sortBy=' + encodeURIComponent(sortBy);
            const ticketDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return ticketDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getDashboardUserAnalytics(projectId) {
        try {
            let url = window.location.origin + this.TICKET + this.GET_DASHBOARD_USER_ANALYTICS;
            url = url.replace('{projectId}', projectId);
            const ticketDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return ticketDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getFeedbackAnalysisByForm(formId) {
        try {
            let url = window.location.origin + this.TICKET + this.GET_FEEDBACK_ANALYSIS_BY_FORM;
            url = url
                .replace('{formId}', formId)
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getCommentsAndUploadFiles(ticketId) {
        try {
            let url = window.location.origin + this.TICKET + this.GET_COMMENTS_AND_UPLOAD_FILES;
            url = url
                .replace('{ticketId}', ticketId)
            const ticketDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return ticketDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async getAnalysisByFormAndEmail(formId, email) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TICKET + this.GET_ANALYSIS_BY_FORM_AND_USER;
        let analysisMap = {
            formId: formId,
            email: email
        }
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(analysisMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async searchTicketListByKeywordInProject(keyword, projectId) {
        try {
            let url = window.location.origin + this.TICKET + this.SEARCH_BY_KEYWORD_AND_PROJECT_ID;
            url = url
                .replace('{keyword}', keyword)
                .replace('{projectId}', projectId)
            const projectDataRet = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return projectDataRet;
        } catch (err) {
            console.log(err);
        }
    }

    async updateTicketStatus(updateTicketMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TICKET + this.UPDATE_TICKET_STATUS;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateTicketMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateTicketReporter(updateTicketMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TICKET + this.UPDATE_TICKET_REPORTER;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateTicketMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateTicketPriority(updateTicketMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TICKET + this.UPDATE_TICKET_PRIORITY;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateTicketMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async addDiscussionComment(updateTicketMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TICKET + this.ADD_DISCUSSION_COMMENT;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateTicketMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async addClientComment(updateTicketMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TICKET + this.ADD_CLIENT_COMMENT;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateTicketMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async escalateTicket(updateTicketMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TICKET + this.ESCALATE_TICKET;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateTicketMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateTicketAssignee(updateTicketMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TICKET + this.UPDATE_TICKET_ASSIGNEE;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(updateTicketMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async createTicket(ticket) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TICKET;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(ticket)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateTicket(ticket) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TICKET;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(ticket)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async getTicketAsPdf(type, id) {
        try {
            let url = window.location.origin + this.TICKET + this.GET_AS_PDF;
            url = url.replace('{type}', type).replace('{id}', id);
            return this.fetch(url, {
                method: 'GET',
                retries: 3,
                retryDelay: 200,
            }).then(data => data.json())
                .then(data => {
                    if (data.error !== undefined) {
                        if (data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        throw new Error(data.error);
                    }
                    return data.body;
                });
        } catch (err) {
            console.log(err);
        }
    }

    async deleteTicket(deleteTicketMap) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.TICKET;
        try{
            return this.fetch(url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(deleteTicketMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }
}

export default TicketService;
